// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLeftSidebar {
  overflow-y: scroll;
  max-height: 95vh;
}

.dashboard-layout__content {
  overflow-y: hidden !important;
}

.Admin__content {
  max-height: unset !important;
}

.YardContainers .r-drawer__content {
  z-index: 5;
}

.YardContainers {
  width: 100%;
  padding: 0 20px 20px 0;
  overflow: scroll;
  max-height: 95vh;
}

.YardContainers__unmuteIcon {
    max-width: 24px;
  }

.YardContainers__muteIcon {
    max-width: 24px;
  }

.YardContainers__selectedContainer {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    margin-bottom: 20px;
    width: 100%;
  }

.YardContainers__selectedContainer-wrapper {
      width: 100%;
      height: 100vh;
    }

.YardContainers__selectedContainer-column {
      font-size: 18px;
      font-weight: bold;
      border: solid 1px var(--color-gray-3);
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }

.YardContainers__selectedContainer-column-row {
        font-size: 16px;
        color: var(--color-blue-3);
      }

.YardContainers .right-sidebar-navigation__content-open {
    background: white;
    box-shadow: 0 2px 2px 0 #bbbcbd;
    padding: 20px;
    height: 100vh;
    overflow-y: scroll;
  }

.YardContainers .CopyButton,
  .YardContainers .PhoneButton {
    display: inline;
    position: relative;
    left: 4px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

.YardContainers td:hover .CopyButton,
  .YardContainers *:hover > .CopyButton,
  .YardContainers *:hover > .PhoneButton,
  .YardContainers td:hover .PhoneButton {
    opacity: 1;
  }

.YardContainers__emptyReturnMatchesTable {
    background: var(--bg-color-0);
    padding: 3px;
    border: solid 1px #d0d0d0;
    flex-grow: 1;
  }

.YardContainers__emptyReturnMatchesTable tbody tr:last-child th,
      .YardContainers__emptyReturnMatchesTable tbody tr:last-child td {
        border-bottom: 0;
      }

.YardContainers__emptyReturnMatchesTable th,
    .YardContainers__emptyReturnMatchesTable td {
      text-align: center;
      border-right: solid 1px var(--color-grayscale-4);
      border-bottom: solid 1px var(--color-grayscale-4);
      padding: 6px;
    }

.YardContainers__emptyReturnMatchesTable th:last-child, .YardContainers__emptyReturnMatchesTable td:last-child {
        border-right: 0;
      }

.YardContainers__emptyReturnMatchesTable-shift {
      display: flex;
      align-items: center;
    }

.YardContainers__emptyReturnMatchesTable-shift-list-item {
        margin-left: 3px;
        display: flex;
      }

.YardContainers__emptyReturnMatchesTable-shift-list-item--red {
          color: var(--color-red-3);
        }

.YardContainers__fixed-pane {
    position: sticky;
    top: 0;
    left: 0;
    background: white;
    padding: 20px 0 0 20px;
    z-index: 5;
  }

.YardContainers__options {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    padding: 0 20px;
  }

.YardContainers__options input {
      width: 200px;
      margin-right: 20px;
    }

.YardContainers__options button {
      margin-right: 20px;
    }

.YardContainers__table {
    width: 100%;
    z-index: 2;

  }

.YardContainers__table thead {
      position: sticky;
      background: white;
      z-index: 4;
      color: #333;
    }

.YardContainers__table tbody::before {
      content: '';
      display: block;
      height: 6px;
    }

.YardContainers__table th {
      cursor: pointer;
      text-align: left;
      padding: 0 8px;
      white-space: nowrap;


    }

.YardContainers__table td {
      padding: 7px;
      border: solid 1px #4b4040aa;
    }

.YardContainers__table th:first-child {
      min-width: 30px;
      padding-right: 10px;
      position: sticky;
      left: 0;
      z-index:3;
      background: white !important;
    }

.YardContainers__table th:nth-child(2) {
      min-width: 120px;
      position: sticky;
      left: 30px;
      background: white !important;
      z-index:3
    }

.YardContainers__table tbody > tr:nth-child(odd) {
      background-color: var(--color-grayscale-3);
    }

.YardContainers__table tbody > tr:nth-child(even) {
      background-color: white;
    }

.YardContainers__table_showMuted th:first-child {
        padding: 0 10px;
      }

.YardContainers__table_row input[type='checkbox'] {
      cursor: pointer;
    }

.YardContainers__table_row-muted {
      color: var(--color-grayscale-5);
      font-style: italic;
    }

.YardContainers__table-job-number {
      min-width: 80px;
    }

.YardContainers__table-leg-status {
      min-width: 100px;
    }

.YardContainers__mute-option {
    position: sticky;
    left: 0;
    z-index: 3;
    background: inherit;
    border-right: none !important;
    border-left: none !important;
  }

.YardContainers__container {
    min-width: 140px;
    position: sticky;
    left: 30px;
    background: inherit;
    box-shadow: inset -4px 0 4px -2px rgb(0 0 0 / 30%);
    border-right: none !important;
    border-left: none !important;
  }

.YardContainers__yard-confirm {
    border-left: none !important;
  }

.YardContainers__small_col {
    max-width: 120px;
  }

.YardContainers__notes {
    min-width: 350px;
    max-height: 175px;
    height: auto;
    overflow-y: auto;
  }

.YardContainers__chassis-no {
    word-wrap: break-word;
    max-width: 110px;
  }

.YardContainers__date-col {
    min-width: 128px;
  }

.YardContainers__checkin-col {
    min-width: 128px;
  }

.YardContainers__terminal-col {
    min-width: 128px;
  }

.YardContainers__not-on-hire-badge {
    color: var(--color-red-3);
    border: 1px solid var(--color-red-3);
  }

.YardContainers__yard-conf {
    display: flex;
    flex-direction: row;
    min-width: 105px;
    text-align: left;
  }

.YardContainers__reserved-by-td {
    min-width: 150px;
  }

.YardContainers__reserved-by {
    display: grid;
    grid-template-columns: 25px 115px;
    column-gap: 5px;
    align-items: center;
    width: 150px;
  }

.YardContainers__reserved-by svg {
      color: #d18700;
      max-width: 25px;
      max-height: 25px;
    }

.YardContainers .container-number-button {
    padding: 0;
  }

.YardContainers .container-number-button-clickable {
    color: var(--color-blue-3);
    border-bottom: 1px solid var(--color-blue-3);
    cursor: pointer;
  }

.YardContainers .container-number-button-active {
    background: var(--color-gray-2);
  }

.YardContainers__loader {
    width: 10%;
    margin: auto;
    height: 100%;
    display: flex;
  }

.YardContainers--selected-active-row {
    background-color: var(--color-green-2) !important;
  }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/Admin/features/YardContainers/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAyTlB;;AAvTE;IACE,eAAe;EACjB;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;EAqBb;;AAnBE;MACE,WAAW;MACX,aAAa;IACf;;AAEA;MACE,eAAe;MACf,iBAAiB;MACjB,qCAAqC;MACrC,aAAa;MACb,aAAa;MACb,sBAAsB;MACtB,6BAA6B;IAM/B;;AAJE;QACE,eAAe;QACf,0BAA0B;MAC5B;;AAIJ;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,kBAAkB;EACpB;;AAEA;;IAEE,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oCAAoC;EACtC;;AAEA;;;;IAIE,UAAU;EACZ;;AAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;IACzB,YAAY;EAkCd;;AA/BI;;QAEE,gBAAgB;MAClB;;AAGF;;MAEE,kBAAkB;MAClB,gDAAgD;MAChD,iDAAiD;MACjD,YAAY;IAKd;;AAHE;QACE,eAAe;MACjB;;AAGF;MACE,aAAa;MACb,mBAAmB;IAUrB;;AARE;QACE,gBAAgB;QAChB,aAAa;MAKf;;AAHE;UACE,yBAAyB;QAC3B;;AAKN;IACE,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,sBAAsB;IACtB,UAAU;EACZ;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;EAUjB;;AARE;MACE,YAAY;MACZ,kBAAkB;IACpB;;AAEA;MACE,kBAAkB;IACpB;;AAGF;IACE,WAAW;IACX,UAAU;;EA6EZ;;AA3EE;MACE,gBAAgB;MAChB,iBAAiB;MACjB,UAAU;MACV,WAAW;IACb;;AAEA;MACE,WAAW;MACX,cAAc;MACd,WAAW;IACb;;AAEA;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,mBAAmB;;;IAGrB;;AAEA;MACE,YAAY;MACZ,2BAA2B;IAC7B;;AAEA;MACE,eAAe;MACf,mBAAmB;MACnB,gBAAgB;MAChB,OAAO;MACP,SAAS;MACT,4BAA4B;IAC9B;;AAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,UAAU;MACV,4BAA4B;MAC5B;IACF;;AAEA;MACE,0CAA0C;IAC5C;;AAEA;MACE,uBAAuB;IACzB;;AAGE;QACE,eAAe;MACjB;;AAGF;MACE,eAAe;IACjB;;AAEA;MACE,+BAA+B;MAC/B,kBAAkB;IACpB;;AAEA;MACE,eAAe;IACjB;;AAEA;MACE,gBAAgB;IAClB;;AAIF;IACE,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;EAC9B;;AAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,kDAAkD;IAClD,6BAA6B;IAC7B,4BAA4B;EAC9B;;AAEA;IACE,4BAA4B;EAC9B;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;AAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,aAAa;IACb,iCAAiC;IACjC,eAAe;IACf,mBAAmB;IACnB,YAAY;EAOd;;AALE;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;IAClB;;AAGF;IACE,UAAU;EACZ;;AAEA;IACE,0BAA0B;IAC1B,4CAA4C;IAC5C,eAAe;EACjB;;AAEA;IACE,+BAA+B;EACjC;;AAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;AAEA;IACE,iDAAiD;EACnD","sourcesContent":[".AdminLeftSidebar {\n  overflow-y: scroll;\n  max-height: 95vh;\n}\n\n.dashboard-layout__content {\n  overflow-y: hidden !important;\n}\n\n.Admin__content {\n  max-height: unset !important;\n}\n\n.YardContainers .r-drawer__content {\n  z-index: 5;\n}\n\n.YardContainers {\n  width: 100%;\n  padding: 0 20px 20px 0;\n  overflow: scroll;\n  max-height: 95vh;\n\n  &__unmuteIcon {\n    max-width: 24px;\n  }\n\n  &__muteIcon {\n    max-width: 24px;\n  }\n\n  &__selectedContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    margin-bottom: 20px;\n    width: 100%;\n\n    &-wrapper {\n      width: 100%;\n      height: 100vh;\n    }\n\n    &-column {\n      font-size: 18px;\n      font-weight: bold;\n      border: solid 1px var(--color-gray-3);\n      padding: 20px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-evenly;\n\n      &-row {\n        font-size: 16px;\n        color: var(--color-blue-3);\n      }\n    }\n  }\n\n  .right-sidebar-navigation__content-open {\n    background: white;\n    box-shadow: 0 2px 2px 0 #bbbcbd;\n    padding: 20px;\n    height: 100vh;\n    overflow-y: scroll;\n  }\n\n  .CopyButton,\n  .PhoneButton {\n    display: inline;\n    position: relative;\n    left: 4px;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n  }\n\n  td:hover .CopyButton,\n  *:hover > .CopyButton,\n  *:hover > .PhoneButton,\n  td:hover .PhoneButton {\n    opacity: 1;\n  }\n\n  &__emptyReturnMatchesTable {\n    background: var(--bg-color-0);\n    padding: 3px;\n    border: solid 1px #d0d0d0;\n    flex-grow: 1;\n\n    tbody tr:last-child {\n      th,\n      td {\n        border-bottom: 0;\n      }\n    }\n\n    th,\n    td {\n      text-align: center;\n      border-right: solid 1px var(--color-grayscale-4);\n      border-bottom: solid 1px var(--color-grayscale-4);\n      padding: 6px;\n\n      &:last-child {\n        border-right: 0;\n      }\n    }\n\n    &-shift {\n      display: flex;\n      align-items: center;\n\n      &-list-item {\n        margin-left: 3px;\n        display: flex;\n\n        &--red {\n          color: var(--color-red-3);\n        }\n      }\n    }\n  }\n\n  &__fixed-pane {\n    position: sticky;\n    top: 0;\n    left: 0;\n    background: white;\n    padding: 20px 0 0 20px;\n    z-index: 5;\n  }\n\n  &__options {\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    padding: 0 20px;\n\n    input {\n      width: 200px;\n      margin-right: 20px;\n    }\n\n    button {\n      margin-right: 20px;\n    }\n  }\n\n  &__table {\n    width: 100%;\n    z-index: 2;\n\n    thead {\n      position: sticky;\n      background: white;\n      z-index: 4;\n      color: #333;\n    }\n\n    tbody::before {\n      content: '';\n      display: block;\n      height: 6px;\n    }\n\n    th {\n      cursor: pointer;\n      text-align: left;\n      padding: 0 8px;\n      white-space: nowrap;\n\n\n    }\n\n    td {\n      padding: 7px;\n      border: solid 1px #4b4040aa;\n    }\n\n    th:first-child {\n      min-width: 30px;\n      padding-right: 10px;\n      position: sticky;\n      left: 0;\n      z-index:3;\n      background: white !important;\n    }\n\n    th:nth-child(2) {\n      min-width: 120px;\n      position: sticky;\n      left: 30px;\n      background: white !important;\n      z-index:3\n    }\n\n    tbody > tr:nth-child(odd) {\n      background-color: var(--color-grayscale-3);\n    }\n\n    tbody > tr:nth-child(even) {\n      background-color: white;\n    }\n\n    &_showMuted {\n      th:first-child {\n        padding: 0 10px;\n      }\n    }\n\n    &_row input[type='checkbox'] {\n      cursor: pointer;\n    }\n\n    &_row-muted {\n      color: var(--color-grayscale-5);\n      font-style: italic;\n    }\n\n    &-job-number {\n      min-width: 80px;\n    }\n\n    &-leg-status {\n      min-width: 100px;\n    }\n\n  }\n\n  &__mute-option {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n    background: inherit;\n    border-right: none !important;\n    border-left: none !important;\n  }\n\n  &__container {\n    min-width: 140px;\n    position: sticky;\n    left: 30px;\n    background: inherit;\n    box-shadow: inset -4px 0 4px -2px rgb(0 0 0 / 30%);\n    border-right: none !important;\n    border-left: none !important;\n  }\n\n  &__yard-confirm {\n    border-left: none !important;\n  }\n\n  &__small_col {\n    max-width: 120px;\n  }\n\n  &__notes {\n    min-width: 350px;\n    max-height: 175px;\n    height: auto;\n    overflow-y: auto;\n  }\n\n  &__chassis-no {\n    word-wrap: break-word;\n    max-width: 110px;\n  }\n\n  &__date-col {\n    min-width: 128px;\n  }\n\n  &__checkin-col {\n    min-width: 128px;\n  }\n\n  &__terminal-col {\n    min-width: 128px;\n  }\n\n  &__not-on-hire-badge {\n    color: var(--color-red-3);\n    border: 1px solid var(--color-red-3);\n  }\n\n  &__yard-conf {\n    display: flex;\n    flex-direction: row;\n    min-width: 105px;\n    text-align: left;\n  }\n\n  &__reserved-by-td {\n    min-width: 150px;\n  }\n\n  &__reserved-by {\n    display: grid;\n    grid-template-columns: 25px 115px;\n    column-gap: 5px;\n    align-items: center;\n    width: 150px;\n\n    svg {\n      color: #d18700;\n      max-width: 25px;\n      max-height: 25px;\n    }\n  }\n\n  .container-number-button {\n    padding: 0;\n  }\n\n  .container-number-button-clickable {\n    color: var(--color-blue-3);\n    border-bottom: 1px solid var(--color-blue-3);\n    cursor: pointer;\n  }\n\n  .container-number-button-active {\n    background: var(--color-gray-2);\n  }\n\n  &__loader {\n    width: 10%;\n    margin: auto;\n    height: 100%;\n    display: flex;\n  }\n\n  &--selected-active-row {\n    background-color: var(--color-green-2) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
